Apt.fn.extend('account.profile', {
	/**
	 * Initialize module
	 */
	init() {
		const priv = this.$private;

		priv.extended = false;

		priv.initProfile();
	},

	/**
	 * Unload module
	 */
	unload() {
		const priv = this.$private;

		priv.unprotect();

		LS.util.reset('profile', priv, [
			'avatar',
			'calls',
			'form',
			'locality',
			'map',
			'messages',
			'metrics',
			'postal',
			'tabs'
		]);
	}
}, {
	/**
	 * Initialize profile
	 */
	initProfile() {
		const scope = this;
		const id = $.context('id');

		scope.root = 'me/profile' + (id ? `s/${id}` : '');

		LS.api.get(scope.root, {
			auth: true,
			success: data => {
				data.profile = data.profile || {
					published: true,
					type: 'agent'
				};

				data.constrain = ! data.profile.bio || data.profile.bio.length < 1000;

				data.profile.visible = data.profile.published &&
					data.profile.approved;

				if (! LS.user.get('admin')) {
					data.restricted = data.profile.visible;
					data.locked = data.restricted && data.source === 'direct';
				}

				data.designations = data.profile.designations || [];
				data.licenses = data.profile.licenses || [];
				data.service_areas = data.profile.service_areas || [];

				scope.data = data;

				scope.id = data.profile.id || null;

				$$('detail').html(
					$.view.render($$('template')[0].textContent, data)
				);

				if (data.profile.visible) {
					$.events.on('.-is-disabled', 'click', (e, el) => {
						LS.util.warn(el.dataset.message || 'Value cannot be edited after publishing');
					}, {
						delegate: '$detail',
						namespace: 'profile'
					});
				}

				$.events.on('input, select, textarea', 'change', (e, el) => {
					const id = el.id || el.dataset.id;

					if (id && id.search(/\.\d+/)) {
						const mode = el.inputMode;
						const numeric = mode === 'decimal' || mode === 'numeric';

						let value = el.value.trim();

						if (value && (numeric || el.nodeName === 'SELECT')) {
							if (numeric) {
								value = LS.util.parseNumber(value);
							}

							value = isNaN(value) ?
								value : Number(value);
						}

						$.app.profile.$set('data.' + id, el.type === 'checkbox' ?
							el.checked : value
						);
					}
				}, {
					delegate: '$detail',
					namespace: 'profile'
				});

				scope.initTabs();
				scope.initAvatar(data);

				scope.protect();

				LS.analytics.record();
			}
		});
	},

	/**
	 * Initialize tabs
	 */
	initTabs() {
		const scope = this;
		const init = {};

		scope.tabs = Apt.fn.tab()
			.init('$tabs', id => {
				if (init[id]) {
					return;
				}

				init[id] = true;

				scope['init' + LS.util.capitalize(id)]();
			});
	},

	/**
	 * Initialize manage
	 */
	initManage() {
		const scope = this;
		const data = scope.data;

		if (data.profile.center) {
			scope.center = data.profile.center;
		}

		if (data.profile.specialties) {
			data.profile.specialties = LS.util.pluck(data.profile.specialties, 'id');
		}

		scope.$form = $$('profileForm');

		LS.form.restrict(scope.$form, 'profile');

		scope.app = $.app.make('profile', {
			view: $$('profileTemplate')[0].textContent,
			target: scope.$form,
			model: {
				data: data,
				promoted: data.profile.promoted,
				published: data.profile.published,
				countries: $.context('countries'),
				designations: $.context('designations'),
				licenses: $.context('licenses'),
				specialties: $.context('specialties'),
				types: $.context('types')
			}
		});

		$$('bio').on('paste', e => {
			const value = (e.clipboardData || window.clipboardData).getData('text');

			if (data.constrain && value.length > 1200) {
				LS.util.warn('Bio must contain at most 1,200 characters');
			}
		}, {
			namespace: 'profile'
		});

		$$('profileSubmit').on('click', () => {
			const data = scope.$form.serialize(true);

			if (scope.center) {
				data.profile.center = scope.center;
			}

			if (data.profile && ! data.profile.published) {
				data.profile.published = '0';
			}

			data.professional = data.professional || '0';

			if (! scope.validate(data)) {
				return;
			}

			LS.common.transition();

			LS.api.request(scope.root, {
				auth: true,
				method: 'patch',
				data: data,
				flash: false,
				namespace: 'profile',
				success: data => {
					$.app.profile.$merge('data.profile', data);

					LS.util.scrollTarget()
						.scrollTop(0);

					LS.util.flash(data.message, 'success');

					scope.unprotect();
				},
				error: (xhr, conf, message) => {
					LS.util.warn(message);

					if (xhr.status !== 422) {
						LS.log.issue('ProfileError', xhr.responseText, {
							status: xhr.status
						});
					}
				},
				complete: () => {
					LS.common.transition(true);
				}
			});
		});

		scope.initModals();
		scope.initToggle();
	},

	/**
	 * Initialize modals
	 */
	initModals() {
		$.events.on('$profileModal', 'click', (e, el) => {
			LS.modal.open({
				model: {
					title: el.dataset.title,
					content: $.view.render('account-profile.modals.' + el.dataset.view)
				},
				width: 520
			});
		}, {
			cancel: true,
			delegate: '$profileForm',
			namespace: 'profile'
		});
	},

	/**
	 * Initialize messages
	 */
	initMessages() {
		const scope = this;

		LS.util.load('account-messages', () => {
			scope.messages = Apt.fn['account.messages']()
				.init({
					path: scope.root,
					empty: "Your profile hasn't received any messages yet.",
					sender: true,
					static: true,
					target: false
				});
		});
	},

	/**
	 * Initialize calls
	 */
	initCalls() {
		const scope = this;

		LS.util.load('account-calls', () => {
			scope.calls = Apt.fn['account.calls']()
				.init({
					path: scope.root,
					empty: "Your profile hasn't received any calls yet.",
					caller: true,
					static: true,
					target: false
				});
		});
	},

	/**
	 * Initialize metrics
	 */
	initMetrics() {
		const scope = this;

		LS.util.load('account-metrics', () => {
			scope.metrics = Apt.fn['account.metrics']()
				.init({
					path: scope.root,
					columns: 3
				});
		});
	},

	/**
	 * Protect from accidental navigation
	 */
	protect() {
		const scope = this;

		scope.protecting = setTimeout(() => {
			LS.confirm = conf => {
				conf.abort();

				LS.modal.confirm('Are you sure you want to leave? Unsaved changes will be lost.', () => {
					LS.confirm = null;

					$.history.go(conf.path);
				});
			}
		}, 10000);
	},

	/**
	 * Remove protection
	 */
	unprotect() {
		clearTimeout(this.protecting);

		delete LS.confirm;
	},

	/**
	 * Validate submission
	 *
	 * @param {Object} data
	 * @returns {Boolean}
	 */
	validate(data) {
		const scope = this;
		const name = data.first_name + data.last_name;

		if (name && ! LS.validate.isMixedCase(name)) {
			LS.util.warn('Name must be "Title Case"');

			return false;
		}

		if (
			data.professional === '1' &&
			data.profile.published === '1'
		) {
			if (! data.specialties) {
				LS.util.warn('You must select one or more specialties');

				LS.util.setScroll('$profileSpecialties');

				return false;
			}

			if (scope.locality && ! scope.locality.val()) {
				LS.util.warn('City selection is invalid', true);

				scope.locality.highlight();

				return false;
			}

			const bio = data.profile.bio;

			let error;

			if (bio) {
				if (bio.length < 150) {
					error = 'Bio must be over 150 characters';
				}
				if (LS.validate.hasUrl(bio)) {
					error = 'Bio cannot contain website links';
				} else if (LS.validate.hasPhone(bio)) {
					error = 'Bio cannot contain phone numbers';
				} else if (LS.validate.hasEmail(bio)) {
					error = 'Bio cannot contain emails';
				}
			} else {
				error = 'Bio field is required';
			}

			if (error) {
				LS.util.warn(error);

				LS.validate.highlight('$bio', true);

				return false;
			}

			if (data.profile.type === 'agent' && ! data.licenses) {
				LS.util.warn('Agents must enter one or more licenses', true);

				LS.util.setScroll('$profileLicenses');

				return false;
			}
		}

		for (const area in data.service_areas || {}) {
			if (! data.service_areas[area].location) {
				LS.util.warn('Service area location is required', true);

				LS.util.setScroll('$profileAreas');

				return false;
			}
		}

		const designations = data.designations;

		if (designations) {
			const categories = LS.util.pluck(designations, 'category_id');

			if (categories.some((val, i) => categories.indexOf(val) !== i)) {
				LS.util.warn('Designation types cannot be repeated');

				LS.util.setScroll('$profileDesignations');

				return false;
			}
		}

		if (data.licenses) {
			const categories = {};

			let index;
			let license;

			for (index in data.licenses) {
				license = data.licenses[index];

				// TODO restore when location bug is resolved
				// if (! license.territory_id) {
				// 	LS.util.warn('License state is required', true);
				//
				// 	return false;
				// }

				if (! categories[license.territory_id]) {
					categories[license.territory_id] = [];
				}

				if (categories[license.territory_id].indexOf(license.category_id) !== -1) {
					LS.util.warn('One license per category and state allowed', {
						category: license.category_id,
						territory: license.territory_id
					});

					return false;
				}

				categories[license.territory_id].push(license.category_id);
			}
		}

		return LS.form.validate(scope.$form);
	}
});